import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sl-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
  @Input() type: AlertType = 'info';
  @Input() closable = false;

  @Output() readonly close = new EventEmitter();

  closeAlert(): void {
    this.close.emit();
  }
}

export type AlertType = 'info' | 'success' | 'warning'; // TODO: 'error' |
